import { GridItem } from '@flos/react-ui';
import ChildAccidentMissingInformationForm from '../ChildAccidentMissingInformationForm';
import { useRecoilValue } from 'recoil';
import { missingInformationAtom } from '../../../../recoil/atoms/missingInformationAtom';

const ChildAccidentMissingInformation = (): React.JSX.Element => {
    const missingInformation = useRecoilValue(missingInformationAtom);
    const { childAccident } = missingInformation;

    if (!childAccident?.length) return <></>;

    return (
        <>
            {childAccident
                .filter((missingInformation) => !!missingInformation.fixedId)
                .map((missingInformation) => {
                    return (
                        <GridItem span={12} key={missingInformation.fixedId}>
                            <ChildAccidentMissingInformationForm
                                childAccidentMissingInformation={missingInformation}
                            />
                        </GridItem>
                    );
                })}
        </>
    );
};

export default ChildAccidentMissingInformation;
